import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';

import { IUTGridData, IUTLoadTrainRequest, IUTShipperProfile } from '@ruby/modules/unit-train/models/unit-train.interface';
import { UTAdvanceSearchActions } from '@ruby/modules/unit-train/store/ut-advance-search.index';
import { ShipperProfileContainer } from '@ruby/shared/dialogs/unit-train/load-train-confirmation/containers/shipper-profile/shipper-profile.container';

@Component({
  selector: 'ng-ut-load-train-confirmation-container',
  templateUrl: './load-train-confirmation.container.html',
  styleUrls: ['./load-train-confirmation.container.scss']
})
export class LoadTrainConfirmationContainer {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { record: Partial<IUTGridData>; loadTrain: IUTLoadTrainRequest },
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<LoadTrainConfirmationContainer>,
    private store: Store
  ) {}

  /**
   * Load Shipment
   *
   * @summary will load shipment
   * @param $data: IUTLoadTrainRequest
   * @returns void
   */
  loadShipment($data: IUTLoadTrainRequest) {
    this.dialog.open(
      ShipperProfileContainer,
      { data: $data, width: '70vw', height: '50vh' }
    ).afterClosed().subscribe((response?: IUTShipperProfile) => {
      if (response) {
        this.dialogRef.close();
        this.store.dispatch(UTAdvanceSearchActions.saveLoadTrainShipmentData({ profile: response, data: $data }));
      }
    });
  }
}
